<template>
  <div class="login-tab text-size-14">
    <div :class="cssClass" class="login-intro px-2 py-3 text-left">
      {{ intro }}
      <div v-if="1">
        <div class="spinner-grow spinner-grow-sm" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="p-2">
      <InputTextValidated
        type="email"
        @enter="onLogin"
        inputClass="login-field"
        :label="$t('login.lblEmail')"
        v-model="form.email"
      />
      <span class="text-danger" v-if="errors.email">
        {{ errors.email[0] }}
      </span>
    </div>
    <div class="p-0 px-2 pt-2">
      <InputTextValidated
        v-on:keyup.enter="onLogin"
        :label="$t('login.lblPassword')"
        @enter="onLogin"
        inputClass="password-field"
        type="password"
        v-model="form.password"
      />
      <span class="text-danger" v-if="errors.password">
        {{ errors.password[0] }}
      </span>
    </div>
    <div class="link-frget-passwerd">
      <button
        @click.stop="onResetPassword"
        class="btn btn btn-sm btn-link pointer"
      >
        {{ $t('login.forgotPassword') }}
      </button>
    </div>
    <div class="p-2">
      <Btn
        full-width
        :loading="signingin"
        @click.native="onLogin"
        :label="$t('login.login')"
      />
    </div>
    <LoginGoogle />
  </div>
</template>

<script>
import { formValidationMixin } from '@/components/mixins/FormValidationMixin.js';
import LoginGoogle from '@/components/Login/LoginGoogle';

export default {
  name: 'LoginTab',
  props: ['intro', 'loading', 'cssClass', 'redirect'],
  mixins: [formValidationMixin],
  components: {
    LoginGoogle,
  },

  data() {
    return {
      signingin: false,
      form: {
        email: null,
        password: null,
      },
    };
  },

  methods: {
    isValidPassword() {
      if (this.form.password.trim() == '') {
        this.showError('password', this.$t('warnings.invalidPassword'));
        return false;
      }
      return true;
    },

    handleLoginError: function (code) {
      if (code == 'invalidAccount') {
        this.invalidEmail = 'login.acountNotFound';
        this.emailIsMissing = true;
        return;
      }

      if (code == 'invalidPassword') {
        this.passwordIsMissing = true;
        return;
      }
    },

    onResetPassword() {
      this.$router.push('/auth/requestreset');
    },

    onLogin() {
      console.log('Login user:', this.form);
      this.clearErrors();
      this.form.email = this.form.email.trim();
      this.form.password = this.form.password.trim();
      if (!this.isValidEmail()) return;
      if (!this.isValidPassword()) return;

      this.signingin = true;
      this.$store
        .dispatch('signin', this.form)
        .then((response) => {
          this.signingin = false;
          console.log('onLogin data :', response.data);
          let data = response.data;
          if (data.error) {
            console.log('Login  was not successfull; Error code:', data.code);
            this.handleLoginError(data.code);
            this.$router.push('/signin').catch((err) => {
              console.log(err);
            }); // to avoid  "Unhandled promise rejection Object { _name: "NavigationDuplicated"
          } else {
            const user = response.data;
            this.$i18n.locale = user.locale;
            let loginCallback = process.env.VUE_APP_LOGIN_CALLBACK;
            if( this.redirect) {
              loginCallback = this.redirect;
            }

            console.log('Login in was  successfull. Calling:', loginCallback);
            console.log('Token:', this.$store.state.token);
            this.$router.push(loginCallback);
            //this.$router.push('home');
          }
          return;
        })
        .catch((error) => {
          this.signingin = false;
          console.log('Login error:', error);
          this.translatesBackendErrors(error);
          this.$router.push('/signin').catch((err) => {
            console.log(err.response);
          }); // to avoid  "Unhandled promise rejection Object { _name: "NavigationDuplicated";
        });
    },
  },
  mounted() {
    // check if signin is called avter email verification
  },
};
</script>

<style lang="scss">
@import '@/styles/colors';

.login-with-google {
  border: 1px solid $light-grey;
  border-radius: 5px;
  padding: 5px;
  margin: 10px;
}
</style>
